'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaListener = exports.MediaListenerUnwrapped = exports.mapDispatchToProps = exports.matchMedias = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _device = require('redux/modules/device');

var _mediaQueries = require('constants/media-queries');

var _debounce = require('helpers/debounce');

var _object = require('helpers/object');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEBOUNCE_MS = 100;

var matchMedias = exports.matchMedias = function matchMedias() {
  return (0, _entries2.default)(_mediaQueries.MEDIA_QUERY_MAP).map(function (_ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        breakpoint = _ref2[0],
        query = _ref2[1];

    return [breakpoint, window.matchMedia(query).matches];
  }).reduce(_object.insertEntry, {});
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  setMediaState: _device.setMediaState
};

var MediaListenerUnwrapped = exports.MediaListenerUnwrapped = function (_Component) {
  (0, _inherits3.default)(MediaListenerUnwrapped, _Component);

  function MediaListenerUnwrapped() {
    (0, _classCallCheck3.default)(this, MediaListenerUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (MediaListenerUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(MediaListenerUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(MediaListenerUnwrapped, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this = this;

      if (__CLIENT__ && !MediaListenerUnwrapped.listener) {
        var listener = function listener() {
          return _this.props.setMediaState(matchMedias());
        };
        // Call listener to set state from the window, then attach debounced listener
        listener();
        MediaListenerUnwrapped.listener = (0, _debounce.debounce)(listener, DEBOUNCE_MS);
        window.addEventListener('resize', MediaListenerUnwrapped.listener);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (__CLIENT__) {
        window.removeEventListener('resize', MediaListenerUnwrapped.listener);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return MediaListenerUnwrapped;
}(_react.Component);

MediaListenerUnwrapped.listener = null;


MediaListenerUnwrapped.propTypes = {
  setMediaState: _propTypes2.default.func.isRequired
};

var MediaListener = exports.MediaListener = (0, _reactRedux.connect)(null, mapDispatchToProps)(MediaListenerUnwrapped);